import { useCallback } from 'react';

export const ComboBoxOption = ({ option, index, isHighlighted, isSelected, onSelect, onHighlight, renderOption, isMulti = false }) => {
    const handleClick = useCallback(
        (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!option.disabled) {
                onSelect(option);
            }
        },
        [option, onSelect]
    );

    const handleMouseEnter = useCallback(() => {
        if (!option.disabled) {
            onHighlight(index);
        }
    }, [option.disabled, index, onHighlight]);

    const className = [
        'skynet-combobox-option',
        isHighlighted && 'skynet-combobox-option-highlighted',
        isSelected && 'skynet-combobox-option-selected',
        option.disabled && 'disabled',
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div className={className} onMouseDown={handleClick} onMouseEnter={handleMouseEnter}>
            {isMulti && (
                <input
                    type="checkbox"
                    className="skynet-combobox-option-checkbox"
                    checked={isSelected}
                    readOnly
                    tabIndex={-1}
                    aria-hidden="true"
                />
            )}

            <span className="skynet-combobox-option-label" title={option.label}>
                {renderOption ? renderOption(option, { isHighlighted, isSelected }) : option.label}
            </span>
        </div>
    );
};
